import "./App.css";
import Layout from "./Components/Layout/Layout";
import Home from "./Components/Home/Home";
import Cart from "./Components/Cart/Cart";
import Products from "./Components/Products/Products";
import Register from "./Components/Register/Register";
import Login from "./Components/Login/Login";
import About from "./Components/About/About";
import Categories from "./Components/Categories/Categories";
import NotFound from "./Components/NotFound/NotFound";
import toast, { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";

import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import ProductDetails from "./Components/ProductDetails/ProductDetails";
import { CartContextProvider } from "./Context/CartContext";
import Checkout from "./Components/checkout/checkout";
import OrderDetails from "./Components/OrderDetails/OrderDetails";
import CustomProductForm from "./Components/CustomProductForm/CustomProductForm";
import OrdersDashboard from "./admin/Components/Orders";
import AdminDashboard from "./admin/pages/AdminDashboard.jsx";
import ProtecredAdmin from "./Components/ProtectedRoute/protectedAdmin";
import ProtectedAdmin from "./Components/ProtectedRoute/protectedAdmin";
import UnauthorizedPage from "./Components/UnauthrizedPage";
import MyOrders from "./Components/MyOrders/MyOrders";
import CategoryDetail from "./Components/CollectionList/CategoryDetail.jsx";

function App() {
  const [userData, setUserData] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(true); // New loading state

  useEffect(() => {
    if (localStorage.getItem("Auth")) {
      saveUserData();
    } else {
      setIsAuthLoading(false); // No auth, stop loading
    }
  }, []);

  function saveUserData() {
    let encodedToken = localStorage.getItem("Auth");
    if (encodedToken) {
      let token = encodedToken.split(" ")[1]; // Extract the token part
      try {
        let decodedToken = jwtDecode(token);

        // Optional: Check token expiry
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          localStorage.removeItem("Auth");
          setUserData(null);
          return;
        }

        setUserData(decodedToken);
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("Auth");
      }
    }
    setIsAuthLoading(false); // Auth check is complete
  }

  const isAdmin = userData?.role === "admin";

  let routers = createBrowserRouter([
    {
      path: "/",
      element: <Layout setUserData={setUserData} userData={userData} />,
      children: [
        { index: true, element: <Home /> },
        { path: "e-commerce-app/", element: <Home /> },
        {
          path: "products",
          element: <Products />,
        },
        {
          path: "product-details/:id",
          element: <ProductDetails />,
        },
        {
          path: "checkout",
          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <Checkout />
            </ProtectedRoute>
          ),
        },
        {
          path: "cart",
          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <Cart />
            </ProtectedRoute>
          ),
        },
        {
          path: "about",
          element: <About />,
        },
        {
          path: "Order-details/:id",
          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <OrderDetails />
            </ProtectedRoute>
          ),
        },
        {
          path: "Custom",
          element: <CustomProductForm />,
        },
        {
          path: "categories",
          element: <Categories />,
        },
        {
          path: "category/:slug",
          element: <CategoryDetail />,
        },
        {
          path: "myorders",
          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <MyOrders />
            </ProtectedRoute>
          ),
        },
        {
          path: "orders",

          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <ProtectedAdmin isAdmin={isAdmin} isAuthLoading={isAuthLoading}>
                <OrdersDashboard />
              </ProtectedAdmin>
            </ProtectedRoute>
          ),
        },
        {
          path: "Items",
          element: (
            <ProtectedRoute isAuthLoading={isAuthLoading} userData={userData}>
              <ProtectedAdmin isAdmin={isAdmin} isAuthLoading={isAuthLoading}>
                <AdminDashboard />
              </ProtectedAdmin>
            </ProtectedRoute>
          ),
        },
        {
          path: "unauthorized",
          element: <UnauthorizedPage />, // Unauthorized page route
        },
        { path: "*", element: <NotFound /> },
      ],
    },
    {
      path: "register",
      element: <Register />,
    },
    {
      path: "login",
      element: <Login saveUserData={saveUserData} />,
    },
  ]);

  return (
    <CartContextProvider>
      <Toaster />
      <RouterProvider router={routers}></RouterProvider>
    </CartContextProvider>
  );
}

export default App;
